const angular = require('angular');
var app = angular.module('learn-controllers');
const moment = require('moment');

/**
 * Edit Journeys Controller
 */
app.controller('editJourney', [
  'Application', 
  'Authorization',
  'Analyze',
  'Journeys',
  'AccessHelper',
  'SurveyHelper',
  '$q',
  '$scope',
  '$location',
  '$translate',
  function (
    Application, 
    Authorization,
    Analyze,
    Journeys,
    AccessHelper,
    SurveyHelper,
    $q,
    $scope,
    $location,
    $translate,
  ) {
    var self = this;
    var routeParameters = Application.navigation.getRouteParameters();
    self.newObj = routeParameters.id === 'new' || !routeParameters.id;
    self.features = Application.features.flags();
    self.allowance = {
      archive: AccessHelper.isAllowed(['admin', 'journeys', 'archive'], null, ['admin', 'creator']),
      create: AccessHelper.isAllowed(['admin', 'journeys', 'create'], null, ['admin', 'creator']),
      edit: AccessHelper.isAllowed(['admin', 'journeys', 'edit'], null, ['admin', 'creator']),
      add_survey: self.features.surveys && AccessHelper.isAllowed(['admin', 'surveys'], null, ['admin']),
    };

    if ((!self.newObj && !self.allowance.edit) || (self.newObj && !self.allowance.create)) {
      Application.navigation.goTo('/explore');
      return;
    }

    self.authtoken = Authorization.getAuthToken();
    self.user = self.authtoken.user;
    self.editSaved = true;
    self.backLocation = Application.navigation.history[Application.navigation.history.length - 2];
    self.denied = false;
    self.archiveInfo = {};
    self.selectedCriteriaIdList = [];
    self.omittedContentTypes = ['journey', 'survey'];
    self.sortableConf = {
      animation: 350,
      chosenClass: 'sortable-chosen',
      handle: '.drag-handle',
      forceFallback: true,
    };

    self.locationChange = $scope.$on('$locationChangeStart', function (event) {
      if (self.editSaved || self.intentionalNavigation) {
        // Allow the route change to progress
        self.locationChange();
        return;
      }

      // Halt the route change and question the action
      self.navigationPath = {};
      self.navigationPath.targetPath = Application.navigation.getPath();
      self.navigationPath.targetSearch = Application.navigation.getUrlParameters();
      self.navigationPath.targetHash = Application.navigation.getHash();

      event.preventDefault();
      self.showDeparture = true;
      self.onLocationChange = function () {
        self.locationChange();
      };
    });

    var lp = {};
    lp.satisfiable_entities = [];
    lp.tags = [];
    lp.draft = true;
    lp.sequential = true;
    lp.lock_scorm = false;
    lp.resource = false;
    lp.allCourseIds = [];
    self.activeTab = 'details';
    self.showSectionDeleteConfirmation = false;
    self.sectionToDelete = {};
    self.intentionalNavigation = false;

    self.navigationDirectory = {
      details: {
        next: 'create',
        previous: null,
        required: ['title', 'description'],
      },
      create: {
        next: 'images',
        previous: 'details',
        required: null,
      },
      images: {
        next: 'settings',
        previous: 'create',
        required: null,
      },
      settings: {
        next: null,
        previous: 'images',
        required: null,
      },
    };

    self.nextSection = function (item) {
      var nextClicked = item ? false : true;
      var item = item ? self.navigationDirectory[item].previous : self.activeTab;
      var next = self.navigationDirectory[item].next;
      var missing = [];
      var allow = true;

      var findIssues = function (check) {
        var current = self.navigationDirectory[check];
        if (current.required) {
          for (var i = 0; i < current.required.length; i++) {
            if (!self.lp[current.required[i]]) {
              allow = false;
              var addField = current.required[i].replace('_', ' ');
              missing.push(addField);
            }
          }
        }
        
        if (check === 'create') {
          if (!self.lp.satisfiable_entities || self.lp.satisfiable_entities.length < 1) {
            allow = false;
            missing.push('steps');
          }
        }

        if (current.previous) {
          findIssues(current.previous);
        }
      };

      findIssues(item);
      if (allow && next) {
        if (self.newObj || !nextClicked) {
          self.activeTab = next;
          Application.scrollTop();
          return;
        }
        self.saveProgress('next').then(function () {
          self.activeTab = next;
          Application.scrollTop();
        });
      }

      if (missing) {
        Application.messaging.addMessage({
          type: 'error',
          text:
            self.translations['edit.general.notification_fieldsMissing'] + ' ' + missing.join(', ') + '.',
          duration: 5,
        });
      }
    };

    self.noChange = function () {
      self.locationChange();
    };

    const searchContentToCriteria = function (content) {
      return content.map(item => {
        const criteria = {
          type: item.type,
          entity: item._id,
          entity_details: {
            title: item.text,
          },
          active: true,
          date_added: new Date(),
          added_by: Application.access.user._id, 
          added_by_details: {
            full_name: Application.access.user.full_name,
          }
        }

        if (item.availabilityInDays) {
          criteria.availability_delay_in_days = item.availabilityInDays;
        }

        return criteria;
      });
    }
  
    self.surveyAssociation = {
      surveysData: [],
      surveyIds: [],
      omittedContentTypes: SurveyHelper.chipSearchOmittedContentTypes,
      initialIdsByType: {survey: []},
      initSurveyData: function() {
        self.surveyAssociation.initialIdsByType.survey = self.lp.surveys;
        self.surveyAssociation.surveyIds.push(self.lp.surveys[0].survey_id);
      }
    };

    self.criteria = {
      showCriteriaSearch: false,
      loading: false,
      activeEditId: '',
      showEditMenu: false,
      addCriteria: function (items) {
        const formattedAdditions = searchContentToCriteria(items);
        self.lp.satisfiable_entities = self.lp.satisfiable_entities.concat(formattedAdditions);
      },
      removeCriteria: function(entityId) {
        for (const [i, entity] of self.lp.satisfiable_entities.entries()) {
          const criteriaIdIndex = self.selectedCriteriaIdList.indexOf(entityId);
          if (criteriaIdIndex > -1) {
            self.selectedCriteriaIdList.splice(criteriaIdIndex, 1);
          }
          if (entity.entity === entityId) {
            self.lp.satisfiable_entities.splice(i, 1);
            return;
          }
        }
      },
      clickHandler: function (criteriaId) {
        self.criteria.activeEditId = criteriaId;
        self.criteria.showEditMenu = true;
      },
      closeHandler: function () {
        self.criteria.activeEditId = '';
        self.criteria.showEditMenu = false;
      }
    }

    self.saveReady = function () {
      var saveObj = JSON.parse(JSON.stringify(self.lp));
      self.missingSection = false;

      if (self.missingSection) {
        Application.messaging.addMessage({
          type: 'error',
          text: self.translations['edit.general.notification_titleMissing'],
          duration: 5,
        });
      }

      return saveObj;
    };

    self.saveProgress = function (next) {
      if (!self.lp._id) {
        return;
      }
      var saveObj = self.saveReady();
      if (self.missingSection) {
        return;
      }
      self.updateIndicator = true;
      if (self.user.is_collaborator) {
        saveObj.approval_required = true;
        saveObj.approved = false;
      }
      return Journeys.update(
        {
          subresource: saveObj._id,
        },
        saveObj
      )
        .$promise.then(function (updatedObj) {
          Analyze.record(
            { resource: 'modifications' },
            { document: updatedObj._id, type: 'journey' }
          );
          Application.analyticsProvider.trackEvent('journey_updated', {
            content: updatedObj._id,
            content_type: 'journey',
            title: updatedObj.title,
          });
          if (self.newObj) {
            Application.messaging.addMessage({
              type: 'success',
              text: `${self.translations['modules.notifications.journey_savedPt1']} ${
                self.lp.title
              } ${self.translations['modules.notifications.journey_savedPt2']}`,
              duration: 5,
            });
          }

          self.updateIndicator = false;
          self.editSaved = true;
        })
        .catch(function (error) {
          self.updateIndicator = false;
          if (error.data && error.data.message) {
            Application.messaging.addMessage({
              type: 'error',
              duration: 7,
              text: error.data.message,
            });
            return;
          }
          Application.messaging.addMessage({
            type: 'error',
            text: self.translations['modules.notifications.content_issue_updating'],
            duration: 5,
          });
          console.log('Error in update: ', error);
        });
    };

    self.saveMessage = function () {
      Application.messaging.addMessage({
        type: 'success',
        text: `${self.translations['modules.notifications.journey_savedPt1']} ${
          self.lp.title
        } ${self.translations['modules.notifications.journey_savedPt2']}`,
        duration: 5,
      });
    };

    self.create = function () {
      var deferred = $q.defer();

      if (!self.newObj || self.lp._id) {
        deferred.reject();
        return deferred.promise;
      }
      self.lp.user = self.user._id;
      var saveObj = self.saveReady();
      if (self.user.is_collaborator) {
        saveObj.approval_required = true;
        saveObj.approved = false;
      }
      Journeys.create(saveObj)
        .$promise.then(function (returnedLp) {
          var newUrl = $location.absUrl() + '/' + returnedLp._id;
          Application.navigation.history.push(newUrl);
          Analyze.record(
            { resource: 'creations' },
            { document: returnedLp._id, type: 'journey' }
          );
          Application.analyticsProvider.trackEvent('journey_created', {
            content: returnedLp._id,
            content_type: 'journey',
            title: self.lp.title,
          });
          Application.messaging.addMessage({
            type: 'success',
            text:
              self.translations['modules.notifications.journey_createdPt1'] +
              ' ' +
              self.lp.title +
              ' ' +
              self.translations['modules.notifications.journey_createdPt2'],
            duration: 5,
          });
          self.newObj = false;
          self.editSaved = true;
          self.showCreateModal = false;
          self.updateIndicator = false;
          self.showDeparture = false;
          self.intentionalNavigation = true;
          Application.navigation.goTo('/host/journeys/' + returnedLp._id);
          deferred.resolve(returnedLp);
        })
        .catch(function (error) {
          if (error.data && error.data.message) {
            Application.messaging.addMessage({
              type: 'error',
              duration: 7,
              text: error.data.message,
            });
          }
          deferred.reject();
          console.log('Error in update: ', error);
        });

      return deferred.promise;
    };
    
    // TODO This really, really, really needs to be centralized and shared throughout the app.
    const typeToPathType = {
      article: 'articles',
      video: 'videos',
      file: 'files',
      track: 'tracks',
      scorm: 'scorm',
      presentation: 'presentations',
      imported_content: 'imported-content',
      workshop: 'workshops',
      multi_session_workshop: 'multi-session-workshops',
      assessment: 'assessments',
    }
  
    // TODO This really, really, really needs to be centralized and shared throughout the app.
    self.getViewContentURL = function (content) {
      return `#/view/${typeToPathType[content.type]}/${content.entity}`;
    };

    self.goBack = function () {
      if (!self.denied || !self.backLocation) {
        Application.navigation.back();
        self.denied = true;
        return;
      }
      self.denied = true;
      var location = self.backLocation.split('/#/');
      if (location.length !== 2) {
        Application.navigation.back();
        return;
      }
      Application.navigation.goTo(location[1]);
    };

    self.modalCreate = function () {
      self.updateIndicator = true;

      self
        .create()
        .then(function (createdObj) {
          self.editSaved = true;
          self.showCreateModal = false;
          self.updateIndicator = false;
        })
        .catch(function (error) {
          self.showCreateModal = false;
          self.updateIndicator = false;
        });
    };

    self.archive = async function() {
      self.showDelete = false;
      try {
        await Journeys.archive({subresource: self.lp._id}, {archived: true}).$promise;
        Application.messaging.addMessage({type: 'success', duration: 6, text: self.translations['edit.journey.archive_success']});
        Application.navigation.goTo('/admin/content');
      } catch (e) {
        console.log(e);
        Application.messaging.addMessage({type: 'error', duration: 6, text: self.translations['edit.journey.archive_error']});
      }
      $scope.$apply();
    }

    self.goTo = function () {
      self.editSaved = true;
      Application.messaging.addMessage({
        type: '',
        text: self.translations['modules.notifications.vewingUnpublishedLearningPath'],
        link: '/edit/journeys/' + self.lp._id,
      });
      Application.navigation.goTo('/view/journeys/' + self.lp._id);
    };

    self.initialize = function () {
      if (!Authorization.hasValidAuthToken()) {
        if (Application.navigation.isRouteSecure()) {
          Application.navigation.goToSignIn();
          return;
        }
      }
      if (
        self.user.role !== 'admin' &&
        self.user.role !== 'creator' &&
        !self.user.is_collaborator
      ) {
        Application.navigation.goTo('/explore');
        return;
      }
      if (self.newObj) {
        self.lp = lp;
        if (self.user.is_collaborator) {
          self.lp.privacy_collaborators.push(self.user._id);
        }
        self.startEditWatch();
        return;
      }

      Journeys.get(
        {
          subresource: routeParameters.id,
        },
        function (data) {
          if (
            !data ||
            data.company !== self.authtoken.company._id ||
            (self.user.is_collaborator &&
              data.privacy_collaborators.length &&
              data.privacy_collaborators.indexOf(self.user._id) === -1)
          ) {
            Application.messaging.addMessage({
              type: 'error',
              text: self.translations['modules.notifications.learningPathNotEditable'],
              duration: 5,
            });
            self.editSaved = true;
            Application.navigation.goToHome();
            return;
          }
          self.lp = data;
          if (self.lp.surveys?.length) {
            self.surveyAssociation.initSurveyData();
          }
          self.startEditWatch();
        },
        function (error) {
          console.log('Error occured getting journey ', routeParameters.id, error);
          Application.notifications.setError(
            self.translations['modules.notifications.unableToGetLearningPath']
          );
        }
      );
    };
    
    self.removeInitialDelay = () => {
      if (self.lp.satisfiable_entities?.length > 0 && self.lp.satisfiable_entities[0].availability_delay_in_days !== 0) {
        self.lp.satisfiable_entities[0].availability_delay_in_days = 0;
      }
    }

    self.startEditWatch = function () {
      $scope.$watch(
        'elpController.lp',
        function (newVal, oldVal) {
          if (!newVal || newVal === oldVal) {
            return;
          }
          self.removeInitialDelay();
          self.editSaved = false;
        },
        true
      );
      $scope.$watch('elpController.surveyAssociation.surveysData', function(newVal, oldVal) {
        if (!newVal || newVal === oldVal) {
          return;
        }
        self.surveyAssociation.surveyIds = newVal.map(survey => survey._id);
      }, true);
  
      $scope.$watch('elpController.surveyAssociation.surveyIds', function(newVal, oldVal) {
        if (!newVal || newVal === oldVal) {
          return;
        }
        self.lp.surveys = newVal.map(surveyId => ({survey_id: surveyId}));
      }, true);
    };

    $translate([
      'edit.general.notification_fieldsMissing',
      'edit.general.notification_titleMissing',
      'edit.general.notification_confirmLeave',
      'modules.notifications.journey_createdPt1',
      'modules.notifications.journey_createdPt2',
      'modules.notifications.journey_savedPt1',
      'modules.notifications.journey_savedPt2',
      'modules.notifications.journey_removed',
      'modules.notifications.learningPathNotEditable',
      'modules.notifications.content_issue_updating',
      'edit.journey.archive_success',
      'edit.journey.archive_error',
    ]).then(function (translations) {
      self.translations = translations;
      self.initialize();
    });
  },
]);
